import styled from "styled-components";

export const Logo = styled.img`
  height: 200px;
  width: 200px;
  object-fit: contain;
`;
